function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.4 12.3c.9-1.2 1.5-2.8 1.5-4.6 0-4-2.9-7.2-6.5-7.2S1.9 3.7 1.9 7.7c0 1.7.6 3.3 1.5 4.6-1.7.6-2.9 2.2-2.9 4.1v2.9c0 2.4 1.9 4.3 4.3 4.3H12c2.4 0 4.3-1.9 4.3-4.3v-2.9c0-2-1.2-3.6-2.9-4.1zm-10-4.6c0-3.2 2.3-5.8 5-5.8s5 2.6 5 5.8-2.3 5.8-5 5.8-5-2.6-5-5.8zm11.5 11.1c0 1.8-1.6 3.2-3.5 3.2H5.5C3.6 22 2 20.6 2 18.8v-2.2c0-1.5 1.2-2.8 2.7-3.1 1.1.8 2.4 1.3 3.8 1.3s2.7-.5 3.8-1.3c1.6.3 2.7 1.6 2.7 3.1v2.2h-.1zM17 6.2h5.8c.4 0 .7-.3.7-.7s-.3-.7-.7-.7H17c-.4 0-.7.3-.7.7s.3.7.7.7zm5.8 2.9H17c-.4 0-.7.3-.7.7s.3.7.7.7h5.8c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm0 4.3h-4.3c-.4 0-.7.3-.7.7s.3.7.7.7h4.3c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm0 4.4h-4.3c-.4 0-.7.3-.7.7s.3.7.7.7h4.3c.4 0 .7-.3.7-.7s-.3-.7-.7-.7z"
});

function SvgContactIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgContactIcon;